export const transformProfilePicture = (profilePicture: string | undefined) =>
  profilePicture?.replace('=s96-c', '=s512-c') || '';
